import React from 'react';
import { 
  FaExclamationTriangle, FaCheckCircle, 
  FaInfoCircle, FaTimes, FaTrash, FaSpinner
} from 'react-icons/fa';
import './ConfirmationModal.css';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'warning',
  loading = false
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger': return <FaExclamationTriangle />;
      case 'success': return <FaCheckCircle />;
      case 'info': return <FaInfoCircle />;
      default: return <FaExclamationTriangle />;
    }
  };

  const getColor = () => {
    switch (type) {
      case 'danger': return '#f44336';
      case 'success': return '#4CAF50';
      case 'info': return '#2196F3';
      default: return '#FF9800';
    }
  };

  return (
    <div className="confirmation-modal-overlay">
      <div className="confirmation-modal">
        <button className="confirmation-modal-close" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="confirmation-modal-content">
          <div 
            className="confirmation-icon"
            style={{ backgroundColor: `${getColor()}15`, color: getColor() }}
          >
            {getIcon()}
          </div>

          <h2 className="confirmation-title">{title}</h2>
          
          <p className="confirmation-message">{message}</p>

          <div className="confirmation-modal-actions">
            <button
              className="confirmation-btn confirmation-btn-cancel"
              onClick={onClose}
              disabled={loading}
            >
              {cancelText}
            </button>
            <button
              className={`confirmation-btn confirmation-btn-confirm confirmation-btn-${type}`}
              onClick={onConfirm}
              disabled={loading}
              style={{ backgroundColor: getColor() }}
            >
              {loading ? (
                <>
                  <FaSpinner className="spinner" />
                  Processing...
                </>
              ) : (
                <>
                  {type === 'danger' && <FaTrash />}
                  {confirmText}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;